import pkg from '../../package.json';

/**
 * Build-time version metadata for the About modal.
 *
 *   APP_VERSION  — SemVer-ish string from package.json. Format
 *                  `${majorPhase}.${chunkPhase}.${patch}` (e.g.
 *                  `0.11.6` = Phase 11, chunk 6, 0-major during
 *                  the build-up to a tagged v1 release).
 *   GIT_SHA      — `git rev-parse --short HEAD` at build time.
 *                  Falls back to `'dev'` when git isn't available
 *                  (sandboxed CI runs, etc.).
 *   GIT_DATE     — `git log -1 --format=%cs` at build time
 *                  (ISO YYYY-MM-DD of the HEAD commit).
 *                  Falls back to `'unknown'`.
 *
 * `__GIT_SHA__` / `__GIT_DATE__` are Vite `define`-replaced string
 * literals; see `vite.config.ts` for the injection. They're literally
 * string substituted into source, no runtime cost.
 */

declare const __GIT_SHA__:  string;
declare const __GIT_DATE__: string;

export const APP_VERSION: string = pkg.version;
export const GIT_SHA:     string = __GIT_SHA__;
export const GIT_DATE:    string = __GIT_DATE__;

/** Pre-formatted display string: `v{version} · {sha} · {date}`. */
export const VERSION_LABEL: string = `v${APP_VERSION} · ${GIT_SHA} · ${GIT_DATE}`;
